import { render, staticRenderFns } from "./ComponentHelp.vue?vue&type=template&id=5c97e49c"
import script from "./ComponentHelp.vue?vue&type=script&lang=js"
export * from "./ComponentHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports